import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function PurchaseGstStat(props){

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [addedby, setAddedby] = useState({ username: '' });
  const [mode, setMode] = useState({ mode: '' });
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState([]);
  const [combinedData, setcombinedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleUser = (event) => {
      setAddedby({
        ...addedby,
        username: event.target.value
      });
    };
    const handleMode = (event) => {
      setMode({
        ...mode,
        mode: event.target.value
      });
    };
  useEffect(() => {
    try {
        axios.get(`${baseUrl}user-search/`)
        .then(function (response) {
            setUserData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
      fetchData();
  }, [startDate, endDate, addedby, mode]);
  useEffect(() => {
      if (combinedData.length > 0) {
        setRows(combinedData);
      }
  }, [combinedData]);

  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}all-pharm-grn/?start_date=${startDateString}&end_date=${endDateString}&addedby=${addedby.username}&mode!=${mode.mode}&status=1`;
  axios.get(url)
    .then(response => {
      setcombinedData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }


  const today = new Date();

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Purchase GST Statement</h3>
      <div className="row">
        <div className="col-md-4">
            <label className="control-label">Select Date</label>
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>

            <div className="col-md-4">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="user" className="form-label">Search by Cashier</label>
              <select name="user" id="username" value={addedby.user} className="form-control"
                            onChange={(event) => handleUser(event)}>
                            <option value="">Select Cashier</option>
              {userData.map((User,index) => (
                <option key={index} value={User.username}>{User.username}</option>
              ))}
            </select>
            </div>
            </div>
            <div className="col-md-4">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="mode" className="form-label">Search by Sales Mode</label>
              <select name="mode" id="mode" value={mode.mode} className="form-control"
                onChange={(event) => handleMode(event)}>
                <option value="">Select Mode</option>
                <option value="CreditPurchase">Credit Purchase</option>
                <option value="CashPurchase">Cash Purchase</option>
              </select>
            </div>
            </div>
      </div>
    {!isLoading && combinedData.length > 0 ? (
        <div className="table-responsive">
          <table className="erp-table-modern">
        <thead>
         <tr>
            <th colSpan="5">Total Sale Amount</th>
            <th colSpan="5">GST Amount</th>
          </tr>
          <tr>
            <th>0%</th>
            <th>5%</th>
            <th>12%</th>
            <th>18%</th>
            <th>28%</th>
            <th>0.0%</th>
            <th>5.0%</th>
            <th>12.0%</th>
            <th>18.0%</th>
            <th>28.0%</th>
          </tr>
        </thead>
        <tbody>
  <tr>
    {Object.values(
      rows.reduce(
        (acc, payment) => {
          const cgstValues = payment.cgst ? payment.cgst.split(",") : [];
          const netValues = payment.netamount ? payment.netamount.split(",") : [];
          for (let i = 0; i < cgstValues.length; i++) {
            const cgst = parseFloat(cgstValues[i].trim());
            const netAmount = netValues[i] ? parseFloat(netValues[i].trim()) : 0;
            if (!isNaN(cgst) && !isNaN(netAmount)) {
              const gstPercent = cgst * 2; // CGST is half of GST
              const calculatedGstAmount = parseFloat((netAmount * gstPercent / 100).toFixed(2));
              if (cgst === 0) {
                acc['0%'] += netAmount;
                acc['0.0%'] += 0; // GST for 0% is always 0
              } else if (cgst === 2.5) {
                acc['5%'] += netAmount;
                acc['5.0%'] += calculatedGstAmount;
              } else if (cgst === 6) {
                acc['12%'] += netAmount;
                acc['12.0%'] += calculatedGstAmount;
              } else if (cgst === 9) {
                acc['18%'] += netAmount;
                acc['18.0%'] += calculatedGstAmount;
              } else if (cgst === 14) {
                acc['28%'] += netAmount;
                acc['28.0%'] += calculatedGstAmount;
              }
            }
          }
          return acc;
        },
        {
          '0%': 0,
          '5%': 0,
          '12%': 0,
          '18%': 0,
          '28%': 0,
          '0.0%': 0,
          '5.0%': 0,
          '12.0%': 0,
          '18.0%': 0,
          '28.0%': 0,
        }
      )
    ).map((value, index) => (
      <td key={index}>{value.toFixed(2)}</td>
    ))}
  </tr>
</tbody>



        </table>
        </div>
        ) : (
        <>loading pls wait....</>
      )}

    </section>
  )
}

export default PurchaseGstStat;
